export const BoxShadow = {
    level1: '0px 2px 8px rgba(0, 0, 0, 0.15)',
    level2: '0px 4px 16px rgba(0, 0, 0, 0.15)',
    level3: '0px 8px 24px rgba(0, 0, 0, 0.2)',
    level4: '0px 12px 32px rgba(0, 0, 0, 0.25)'
}